export default __webpack_public_path__ + "static/media/subscriptions.562c5fe0.svg";